/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_App_ResearchInputs */

const en_why_listening_app_research = /** @type {(inputs: Why_Listening_App_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research-paper reader`)
};

const es_why_listening_app_research = /** @type {(inputs: Why_Listening_App_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lector de artículos científicos`)
};

/**
* | output |
* | --- |
* | "Research-paper reader" |
*
* @param {Why_Listening_App_ResearchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_app_research = /** @type {((inputs?: Why_Listening_App_ResearchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_App_ResearchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_app_research(inputs)
	return en_why_listening_app_research(inputs)
});